import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './common/SafeIcon';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import TermVsWholeLife from './pages/TermVsWholeLife';
import OnlineVsAgent from './pages/OnlineVsAgent';
import CityInsurancePage from './pages/CityInsurancePage';

const { FiX } = FiIcons;

function App() {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <LanguageProvider>
      <Router>
        <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50">
          <Header />
          
          <Routes>
            <Route path="/" element={<HomePage setShowVideo={setShowVideo} />} />
            <Route path="/term-vs-whole-life" element={<TermVsWholeLife />} />
            <Route path="/online-vs-agent" element={<OnlineVsAgent />} />
            <Route path="/california/:citySlug/:keywordSlug" element={<CityInsurancePage />} />
          </Routes>
          
          <Footer />

          {/* Video Modal */}
          {showVideo && (
            <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
              <motion.div
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-hidden"
              >
                <div className="flex justify-between items-center p-4 border-b">
                  <h3 className="text-xl font-semibold">Term vs Whole Life Insurance Guide</h3>
                  <button
                    onClick={() => setShowVideo(false)}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <SafeIcon icon={FiX} className="text-2xl" />
                  </button>
                </div>
                <div className="aspect-video">
                  <iframe
                    width="100%"
                    height="100%"
                    src="https://www.youtube.com/embed/EtFzDH0Bh8w"
                    title="Term vs Whole Life Insurance"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
              </motion.div>
            </div>
          )}
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;